import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, ListItemButton, ListItemText } from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import type { SlaEditorTarget } from "model/slaEditorModel";
import React, { useState } from "react";
import { useSlaModelDraftContext } from "./slaModelDraftContext";
import SlaTargetForm from "./SlaTargetForm";

/**
 * Sezione richiudibile "SLA" del pannello proprieta' del designer, con lo stesso
 * schema di "Proprieta' primarie"/"Proprieta' specifiche" (`ListItemButton` +
 * `Collapse`). Senza SLA attivo nell'organizzazione non si rende.
 */
interface SlaDesignerSectionProps {
  target: SlaEditorTarget;
}

const SlaDesignerSection = ({ target }: SlaDesignerSectionProps) => {
  const translations = useTranslations();
  const sla = useSlaModelDraftContext();
  const [open, setOpen] = useState<boolean>(true);

  if (!sla?.available) return null;

  return (
    <React.Fragment>
      <ListItemButton id="sla-designer-section" onClick={() => setOpen((prev) => !prev)}>
        <ListItemText primary={getTranslation(translations, "pm.propertyeditor.sla")} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse sx={{ pt: 2 }} timeout="auto" unmountOnExit in={open}>
        <SlaTargetForm target={target} />
      </Collapse>
    </React.Fragment>
  );
};

export default SlaDesignerSection;
